import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="realities--document"
// Handles file uploads in the sidebar and syncs them to the hidden
// file inputs inside the main form so files are included on submit.
export default class extends Controller {
  handleOwnershipUpload(event) {
    this.syncFile(event, "main-ownership-document-input")
  }

  handlePurchaseAgreementUpload(event) {
    this.syncFile(event, "main-purchase-agreement-input")
  }

  syncFile(event, targetId) {
    const file = event.target.files[0]
    if (!file) return

    const mainInput = document.getElementById(targetId)
    if (mainInput) {
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      mainInput.files = dataTransfer.files
      mainInput.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
